// extracted by mini-css-extract-plugin
export var card = "_0-1";
export var shell = "_0-0";